import { Component, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { DataStorageService } from '../../services/data-storage.service';
import { ThankYouOwner } from '../../models/thank-you-owner.model';

/**
 * Component that displays a thank you message after successful application submission
 * Shows user details and a button to return to the home page
 */
@Component({
    selector: 'app-thank-you',
    templateUrl: './thank-you.component.html',
    styleUrl: './thank-you.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ThankYouComponent implements OnInit {
  private readonly dataStorageService = inject(DataStorageService);
  
  public firstOwner!: ThankYouOwner;

  public async ngOnInit(): Promise<void> {
    // Ensure the draft is hydrated in case the user landed here via a refresh.
    await this.dataStorageService.ready;
    const personalDetails = this.dataStorageService.getItem<any>('personalDetailsForm');

    this.firstOwner = {
      firstName: personalDetails?.firstName,
      lastName: personalDetails?.lastName,
      emailAddress: personalDetails?.emailAddress
    };

    // Discard the server-side draft now that the application is submitted and
    // the confirmation details have been read.
    this.dataStorageService.clearDraft();
  }
}
